import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SimpleSelect(props) {
  const classes = useStyles();
  const [time, setTime] = React.useState(props.value ?? '');

  const handleChange = (event) => {
    setTime(event.target.value);
    props.Callback(event.target.value)
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel id="demo-simple-select-filled-label">{props.InputLabel}</InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={time}
        onChange={handleChange}>
        {props.items.map((x,i) => {
          return (<MenuItem  key={`slmik${i}_`} value={x.value}>{x.text}</MenuItem>)
        })}
      </Select>
      <InputAdornment position="end"><img className="stopwatch" src={require('./../img/stopwatch.png')} alt="" /></InputAdornment>
    </FormControl>
  );
}